<template>
  <div v-if="insurer">
    <v-card
      class="rounded-lg"
      :class="
        isPaymentStep ? 'mt-7 application-summary-card__wrapper' : 'mt-11'
      "
    >
      <v-row class="header mx-0 rounded-t-lg">
        <v-col class="px-6 py-0 d-flex align-center">
          <p class="white--text font-20 font-weight-bold ma-0">
            Your Home Insurance quote
          </p>
        </v-col>
      </v-row>
      <v-row class="main mx-0 rounded-b-lg overflow-hidden">
        <TheD2CQuote
          :paymentFrequency="applicationPaymentFrequency"
          :showPayByCreditDebitCardMessage="showPayByCreditDebitCardMessage"
          :showWarningQuoteExpireMessage="false"
          :cover="getCover"
          :insurer="insurer"
          :isPaymentStep="isPaymentStep"
          isSelected
          :showMoreInfoOnMobile="
            (showMoreInfoOnMobile &&
              !frequencyShowFindOutMore.includes(applicationPaymentFrequency) &&
              !showPayByCreditDebitCardMessage) ||
            (showMoreInfoOnMobile && showPayByCreditDebitCardMessage) ||
            (showMoreInfoOnMobile && applyResponse.QuoteStatus === SUBMITTED)
          "
          @showD2CPremiumBreakdown="showD2CPremiumBreakdown"
        ></TheD2CQuote>
      </v-row>
      <div
        v-if="
          (isPaymentStep &&
            applyResponse.QuoteStatus !== SUBMITTED &&
            $vuetify.breakpoint.mdAndDown &&
            frequencyShowFindOutMore.includes(applicationPaymentFrequency) &&
            !showPayByCreditDebitCardMessage) ||
          (!isPaymentStep && applyResponse.QuoteStatus !== SUBMITTED)
        "
        class="d-flex align-center mt-7"
      >
        <span class="font-14">
          You will pay <b>{{ totalPayable | formatCurrency }}</b> in total if
          you choose to pay monthly, which means that you pay
          <b>{{ creditCharge | formatCurrency }}</b> more than if you paid for
          your policy in full today. This is because there is an interest charge
          applied when paying monthly.
          <a
            href="javascript:"
            class="blue-link"
            @click="showModal('DialogContentQuoteMoreDetail')"
            >Find out more</a
          >
        </span>
      </div>
      <v-row
        v-if="
          isPaymentStep &&
          showMoreInfoOnMobile &&
          frequencyShowFindOutMore.includes(applicationPaymentFrequency) &&
          !showPayByCreditDebitCardMessage &&
          isShowHomeInsuranceQuoteDetail
        "
        class="more-info mx-0 rounded-lg overflow-hidden"
      >
        <v-col class="mt-3 pt-6 col-12 d-sm-block d-lg-none">
          <v-row class="insurance">
            <v-col
              v-if="isBuildingsCover"
              class="col-12 mobile-price-container"
            >
              <h2 class="insurance-heading">Buildings Insurance</h2>
              <div class="pl-6 pl-lg-0 insurance-section">
                <b>{{
                  getCover.buildingsCover.amount
                    | formatCurrency(AMOUNT_INSURED_FORMAT)
                }}</b>
                cover
              </div>
              <div class="pl-6 pl-lg-0 insurance-section">
                <b>{{
                  getCover.buildingsCover.excess
                    | formatCurrency(AMOUNT_INSURED_FORMAT)
                }}</b>
                excess
              </div>
              <div class="pl-6 pl-lg-0 insurance-section">
                <b>{{
                  getQuoteExcessConfiguration?.HomeInsurance
                    ?.BuildingsWaterExcess
                    | formatCurrency(AMOUNT_INSURED_FORMAT)
                }}</b>
                escape of water excess
              </div>
              <div class="pl-6 pl-lg-0 insurance-section">
                <b>{{
                  getQuoteExcessConfiguration?.HomeInsurance
                    ?.BuildingsSubsidenceExcess
                    | formatCurrency(AMOUNT_INSURED_FORMAT)
                }}</b>
                subsidence excess
              </div>
            </v-col>
            <v-col v-if="isBuildingsCover" class="col-12 mobile-divided">
              <div class="accidential-damage pt-6">
                <div class="insurance-section font-weight-bold">
                  Accidental damage
                </div>
                <div class="pl-6 pl-lg-0 insurance-section d-flex">
                  <v-icon
                    v-if="insurer.selectedQuote?.BuildingsAD"
                    class="icon darkgreen-icon"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <v-icon v-else class="icon red-icon">mdi-close-circle</v-icon>
                  <div
                    v-if="insurer.selectedQuote?.BuildingsAD"
                    class="accidental-damage__text"
                  >
                    Included
                  </div>
                  <div v-else class="accidental-damage__text">Not included</div>
                </div>
              </div>
            </v-col>
            <v-col v-if="isContentsCover" class="col-12 mobile-price-container">
              <h2 class="insurance-heading">Contents Insurance</h2>
              <div class="pl-6 pl-lg-0 insurance-section">
                <b>{{
                  getCover.contentsCover.amount
                    | formatCurrency(AMOUNT_INSURED_FORMAT)
                }}</b>
                cover
              </div>
              <div class="pl-6 pl-lg-0 insurance-section">
                <b>{{
                  getCover.contentsCover.excess
                    | formatCurrency(AMOUNT_INSURED_FORMAT)
                }}</b>
                excess
              </div>
              <div class="pl-6 pl-lg-0 insurance-section">
                <b>{{
                  getQuoteExcessConfiguration?.HomeInsurance?.ContentWaterExcess
                    | formatCurrency(AMOUNT_INSURED_FORMAT)
                }}</b>
                escape of water excess
              </div>
            </v-col>
            <v-col v-if="isContentsCover" class="col-12 mobile-divided">
              <div class="accidential-damage pt-6">
                <div class="insurance-section font-weight-bold">
                  Accidental damage
                </div>
                <div class="pl-6 pl-lg-0 insurance-section d-flex">
                  <v-icon
                    v-if="insurer.selectedQuote?.ContentsAD"
                    class="icon darkgreen-icon"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <v-icon v-else class="icon red-icon">mdi-close-circle</v-icon>
                  <div
                    v-if="insurer.selectedQuote?.BuildingsAD"
                    class="accidental-damage__text"
                  >
                    Included
                  </div>
                  <div v-else class="accidental-damage__text">Not included</div>
                </div>
              </div>
            </v-col>
            <v-col
              v-if="showMoreInfoOnMobile"
              :class="['additional-cover', 'selected-quote-mobile-view']"
            >
              <h2 class="px-md-6 mb-md-2">Additional cover</h2>
              <div
                class="additional-cover__content pb-7 pb-lg-4 pb-xl-4 d-flex flex-column flex-lg-row flex-xl-row justify-space-between pt-5 pt-lg-7 pt-xl-5 px-lg-6"
              >
                <div class="cover d-flex font-weight-bold">
                  <div class="d-flex align-start pl-6 pl-lg-0">
                    <v-icon
                      v-if="getCover.homeEmergency"
                      class="icon darkgreen-icon"
                      >mdi-checkbox-marked-circle</v-icon
                    >
                    <v-icon v-else class="icon red-icon"
                      >mdi-close-circle</v-icon
                    >
                  </div>
                  <div
                    :class="[
                      'cover-text',
                      getCover.homeEmergency
                        ? 'cover-text__green'
                        : 'cover-text__red',
                    ]"
                  >
                    <div class="cover-title">Home emergency</div>
                    <div v-if="getCover.homeEmergency" class="cover-included">
                      Included
                    </div>
                    <div v-else class="cover-included">Not included</div>
                  </div>
                </div>
                <div class="cover d-flex font-weight-bold">
                  <div class="d-flex align-start pl-6 pl-lg-0">
                    <v-icon
                      v-if="getCover.legalExpenses"
                      class="icon darkgreen-icon"
                      >mdi-checkbox-marked-circle</v-icon
                    >
                    <v-icon v-else class="icon red-icon"
                      >mdi-close-circle</v-icon
                    >
                  </div>
                  <div
                    :class="[
                      'cover-text',
                      getCover.legalExpenses
                        ? 'cover-text__green'
                        : 'cover-text__red',
                    ]"
                  >
                    <div class="cover-title">Legal expenses</div>
                    <div v-if="getCover.legalExpenses" class="cover-included">
                      Included
                    </div>
                    <div v-else class="cover-included">Not included</div>
                  </div>
                </div>
                <div class="cover d-flex font-weight-bold">
                  <div class="d-flex align-start pl-6 pl-lg-0">
                    <v-icon
                      v-if="specifiedValuables.count > 0"
                      class="icon darkgreen-icon"
                      >mdi-checkbox-marked-circle</v-icon
                    >
                    <v-icon v-else class="icon red-icon"
                      >mdi-close-circle</v-icon
                    >
                  </div>
                  <div
                    :class="[
                      'cover-text',
                      specifiedValuables.count > 0
                        ? 'cover-text__green'
                        : 'cover-text__red',
                    ]"
                  >
                    <div class="cover-title">Specified valuables</div>
                    <div class="cover-included">
                      {{ specifiedValuables.count }}
                      {{ specifiedValuables.count !== 1 ? "Items" : "Item" }}
                      <span v-if="specifiedValuables.count >= 1"
                        >-
                        {{
                          specifiedValuables.sum
                            | formatCurrency(AMOUNT_INSURED_FORMAT)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="cover d-flex font-weight-bold">
                  <div class="d-flex align-start pl-6 pl-lg-0">
                    <v-icon
                      v-if="additionalCoverAmount > 0"
                      class="icon darkgreen-icon"
                      >mdi-checkbox-marked-circle</v-icon
                    >
                    <v-icon v-else class="icon red-icon"
                      >mdi-close-circle</v-icon
                    >
                  </div>
                  <div
                    :class="[
                      'cover-text',
                      additionalCoverAmount > 0
                        ? 'cover-text__green'
                        : 'cover-text__red',
                    ]"
                  >
                    <div class="cover-title">Additional cover</div>
                    <div
                      v-if="additionalCoverAmount > 0"
                      class="cover-included"
                    >
                      Included -
                      {{
                        additionalCoverAmount
                          | formatCurrency(AMOUNT_INSURED_FORMAT)
                      }}
                    </div>
                    <div v-else class="cover-included">Not included</div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>

    <div class="view-more-info__wrapper d-block d-lg-none">
      <a
        v-if="showMoreInfoOnMobile"
        @click="showMoreInfoOnMobile = false"
        class="view-link view-less-link"
      >
        <span>View less information</span>
        <v-icon> mdi-chevron-up </v-icon>
      </a>
      <a
        v-else
        @click="showMoreInfoOnMobile = true"
        class="view-link view-more-link"
      >
        <span>View more information</span>
        <v-icon> mdi-chevron-down </v-icon>
      </a>
    </div>

    <BaseDialog
      ref="D2CDialogContentPremiumBreakdown"
      windowClass="pa-0 pa-xl-4 pb-xl-0"
      headerClass="pa-4 d2c-dialog-header"
      contentClass="d2c-breakdown-content"
      dark2Icon
    >
      <template v-slot:content="{ data }">
        <D2CDialogContentPremiumBreakdown
          :breakdownModel="data"
        ></D2CDialogContentPremiumBreakdown>
      </template>
    </BaseDialog>

    <v-alert
      v-if="showPayByCreditDebitCardMessage"
      color="var(--blue-100)"
      class="alert-credit-card-message"
    >
      <div class="d-flex flex-no-wrap">
        <div class="mr-3">
          <v-icon color="var(--blue-500)">mdi-information</v-icon>
        </div>
        <div>
          <p>
            <span class="font-weight-bold">Important!</span>&nbsp;As you've
            chosen to pay by annual credit/debit card, you've been opted out of
            our annual renewal service. If you'd prefer to opt into our
            auto-renewal service, please change your payment method to
            <strong>Direct Debit</strong> above.
          </p>
          <p>
            If you remain opted out of our automatic renewal service, please
            make sure you have adequate insurance cover in place once your
            Paymentshield policy comes to an end.
          </p>
          <p>
            If you own a home with a mortgage, it's often a condition of your
            mortgage agreement to maintain continuous buildings insurance to
            protect your home against serious damage such as fire or flood.
          </p>
        </div>
      </div>
    </v-alert>
  </div>
</template>

<script>
import PremiumBreakdownMixin from "@/Mixins/PremiumBreakdownMixin";
import BuildingsContentsVisibility from "@/Mixins/QuoteResults/BuildingsContentsVisibility";
import {
  CALL_CHANNEL,
  DIRECTDEBIT,
  MONTHLY,
  MONTHLY_3_MONTHS_DEFERRED,
  SUBMITTED,
} from "@/constants/common.constants.js";
import { CONFIG_CONTENTS_D2C } from "@/constants/contents-config.constants";
import { UNSPECIFIED_PERSONAL_POSSESSIONS_D2C } from "@/constants/possessions-options";
import { INSURER_TYPE } from "@/constants/insurer.constants.js";
import { AMOUNT_INSURED_FORMAT } from "@/constants/currency-format.constants";
import {
  APPLICATION_MODULE,
  DIALOG_MODULE,
  QUESTIONS_MODULE,
  STEPS_MODULE,
} from "@/store/types/module-types";
import { mapGetters, mapMutations, mapState } from "vuex";
import { getNamePageSuccessByJourney } from "@/common/navigating";
export default {
  name: "D2CLayoutApplicationSummaryCard",
  components: {
    TheD2CQuote: () => import("@/components/QuoteResult/TheD2CQuote.vue"),
    BaseDialog: () => import("@/components/BaseComponents/BaseDialog.vue"),
    D2CDialogContentPremiumBreakdown: () =>
      import("@/components/QuoteResult/D2CDialogContentPremiumBreakdown.vue"),
  },
  props: {
    useRetrievedPaymentInfo: {
      type: Boolean,
      default: false,
    },
    isShowHomeInsuranceQuoteDetail: {
      type: Boolean,
      default: true,
    },
    isPaymentStep: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [PremiumBreakdownMixin, BuildingsContentsVisibility],
  computed: {
    ...mapGetters(APPLICATION_MODULE, [
      "selectedQuote",
      "getRetrievedQuotePaymentFrequency",
      "getRetrievedQuotePaymentMethod",
    ]),
    ...mapGetters(QUESTIONS_MODULE, [
      "callChannel",
      "getCover",
      "specifiedValuables",
      "getQuoteExcessConfiguration",
    ]),
    ...mapState(APPLICATION_MODULE, [
      "activeQuote",
      "applyResponse",
      "questionMap",
    ]),
    ...mapState(STEPS_MODULE, ["paymentDetailStep"]),
    ...mapGetters(STEPS_MODULE, ["totalSteps"]),
    currentRouteName() {
      return this.$route.name;
    },
    showPayByCreditDebitCardMessage() {
      return (
        this.questionMap.PaymentMethod?.Value === "CreditCard" &&
        getNamePageSuccessByJourney() !== this.currentRouteName
      );
    },
    insurerImage() {
      return this.insurerImageHelper
        ? require("@/assets/images/insurers/" +
            this.insurerImageHelper +
            ".png")
        : null;
    },
    insurerImageHelper() {
      const insurerName = this.selectedQuote?.InsurerName;
      if (!insurerName) return "";

      return INSURER_TYPE.find(
        (insurer) => insurer.name.toLowerCase() === insurerName.toLowerCase()
      )?.image;
    },
    applicationPaymentFrequency() {
      if (this.useRetrievedPaymentInfo) {
        return this.getRetrievedQuotePaymentFrequency;
      } else {
        return this.questionMap.PaymentFrequency?.Value;
      }
    },
    applicationPaymentMethod() {
      if (this.useRetrievedPaymentInfo) {
        return this.getRetrievedQuotePaymentMethod;
      } else {
        return this.questionMap.PaymentMethod?.Value;
      }
    },
    ddMonthly() {
      return (
        this.applicationPaymentMethod === "DirectDebit" &&
        this.applicationPaymentFrequency === "Monthly"
      );
    },
    ddDeferred() {
      return (
        this.applicationPaymentMethod === "DirectDebit" &&
        this.applicationPaymentFrequency === "Monthly3MonthsDeferred"
      );
    },
    insurer() {
      return this.activeQuote;
    },
    additionalCoverAmount() {
      if (!this.getCover || !this.getCover.unspecifiedPpAmount) {
        return 0;
      }
      const collection =
        this.getCover.contentsCover?.amount >= CONFIG_CONTENTS_D2C.default
          ? UNSPECIFIED_PERSONAL_POSSESSIONS_D2C.higherUnspecifiedAmounts
          : UNSPECIFIED_PERSONAL_POSSESSIONS_D2C.standardUnspecifiedAmounts;
      const value =
        collection.find(
          (amount) => amount.value === this.getCover.unspecifiedPpAmount
        )?.numberValue ?? 0;

      return value;
    },
    breakdownModel() {
      return this.buildPremiumBreakdownModel(
        this.insurer.selectedQuote,
        DIRECTDEBIT,
        MONTHLY
      );
    },
    totalPayable() {
      return this.breakdownModel.price.Values.TotalAmountPayable;
    },
    creditCharge() {
      return this.breakdownModel.premium.CreditDetails.CreditCharge;
    },
  },
  data() {
    return {
      D2C_CALL_CHANNEL: CALL_CHANNEL.referralSelfServe,
      frequencyShowFindOutMore: [MONTHLY, MONTHLY_3_MONTHS_DEFERRED],
      showMoreInfoOnMobile: false,
      AMOUNT_INSURED_FORMAT,
      SUBMITTED,
    };
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    breakdown(frequency, selectedQuote) {
      const eventName = "showPremiumBreakdown" + frequency;
      this.$emit(eventName, selectedQuote);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-color: $black-3;
  height: 48px;
}

.more-info {
  margin-top: 63px;
  border: 1px solid #7c869a;
}

.main {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;

  .left {
    border-right: solid 1px #7c869a;
  }

  .middle {
    background-color: $gray-light-5;

    h1 {
      font-size: 40px;
    }
  }

  .right {
    border-left: solid 1px #7c869a;
  }
}

.view-more-info__wrapper {
  text-align: center;
  margin-top: 41px;
  margin-bottom: 33px;
  a {
    gap: 8px;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    text-align: center;
    color: #106175;
    user-select: none;
    display: inline-flex;
    align-items: center;
    letter-spacing: 0;
    span {
      letter-spacing: 0.4;
    }
    i {
      color: #106175;
      font-size: 20px;
    }
  }
}

.icon {
  font-size: 20px;
  &.darkgreen-icon {
    color: #1d8649;
  }

  &.red-icon {
    color: var(--red-500);
  }

  &.blue-icon {
    color: #5285c0;
  }
}

.insurance {
  padding: 0 !important;
  .mobile-divided {
    padding: 0 24px 35px !important;
    margin: 0 0 33px !important;
    border-bottom: 1px solid #7c869a;
  }
  .mobile-price-container {
    padding: 0 24px;
    .insurance-heading {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.4;
      margin-bottom: 10px;
      font-size: 22px;
      line-height: 28px;
    }
  }
  .accidental-damage__text {
    margin: 0 8px 0 15px;
  }
  .additional-cover {
    margin: 0 24px;
    &.col {
      padding: 0;
    }
    h2 {
      padding-left: 0 !important;
    }
  }
}

.cover-text {
  margin-left: 9px;
  &__green {
    .cover-included {
      color: #1d8649;
    }
  }
  &__red {
    .cover-included {
      color: var(--red-500);
    }
  }
}

a.blue-link {
  color: var(--blue-500);
  text-decoration: underline;
  font-weight: bold;
}

// xs to sm breakpoint
@media screen and (max-width: ($grid-breakpoints-sm - 1)) {
  .header {
    height: auto;
    padding: 9px 0;
  }

  .main {
    .left {
      border-right: 0;
      border-bottom: solid 1px #7c869a;
    }

    .middle {
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  }
}

// sm to md breakpoint
@media screen and (min-width: ($grid-breakpoints-sm - 1)) and (max-width: ($grid-breakpoints-md - 1)) {
  .main {
    .middle {
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
